import { useCallback, useEffect, useState } from "react";
import { useUrlState } from "@/lib/navState";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";

const wrap = "ti-dark -m-3 min-h-[calc(100vh-3rem)] w-full max-w-full overflow-x-hidden px-4 py-4 pb-28 sm:-m-5 sm:px-6 lg:-m-5 lg:-mb-5 lg:px-8 lg:py-5 lg:pb-6";
const SB = { MATCHED: "text-emerald-300", SECURITY_ONLY: "text-amber-300", ADMIN_ONLY: "text-amber-300", OUT_WITHOUT_IN: "text-rose-300", DUPLICATE: "text-rose-300", MISSING_PHOTO: "text-amber-300", OPEN_STAY: "text-blue-300", RESOLVED: "text-emerald-400", PENDING: "text-[#7E91AC]" };

export default function SecurityLog() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useUrlState("q", "");
  const [type, setType] = useUrlState("type", "");
  const load = useCallback(() => {
    api.get("/security/movements", { params: { q, type, page: 1 } }).then((r) => setRows(r.data.rows || [])).catch(() => {});
  }, [q, type]);
  useEffect(() => { load(); }, [load]);

  return (
    <div className={wrap} data-testid="security-log-page">
      <div className="mx-auto w-full min-w-0 max-w-6xl">
        <h1 className="font-heading text-xl font-extrabold text-white">Log Kendaraan</h1>
        <div className="mt-3 flex flex-wrap gap-2">
          <Input data-testid="log-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari nopol…" className="h-10 w-48 border-white/12 bg-white/5 text-white" />
          {["", "IN", "OUT"].map((t) => <button key={t} data-testid={`log-filter-${t || "all"}`} onClick={() => setType(t)} className={`h-10 rounded-lg border px-3 text-xs font-semibold ${type === t ? "border-blue-400/50 bg-blue-500/20 text-blue-200" : "border-[#29466D] bg-[#102544] text-[#C3D0E2]"}`}>{t || "Semua"}</button>)}
        </div>
        <div className="mt-3 grid gap-2 lg:hidden">
          {rows.map((m) => (
            <div key={m.id} className="ti-dcard min-w-0 p-3" data-testid="log-card">
              <div className="flex items-center justify-between"><span className="font-mono text-sm font-bold text-white">{m.license_plate}</span><span className={`text-xs font-bold ${m.type === "IN" ? "text-emerald-300" : "text-blue-300"}`}>{m.type}</span></div>
              <div className="mt-1 text-[11px] text-[#AAB8CC]">{m.date} {m.time} · {m.number} · WO {m.wo_number || "-"}</div>
              <div className="mt-1 flex items-center justify-between text-[11px]"><span className="text-[#C3D0E2]">{m.officer_name}</span><span className={SB[m.recon_status] || "text-[#7E91AC]"}>{m.recon_status}</span></div>
              <div className="mt-1 flex gap-1">{m.photo_ids.map((pid) => <PhotoThumb key={pid} pid={pid} />)}</div>
            </div>
          ))}
          {rows.length === 0 && <p className="text-sm text-[#7E91AC]">Belum ada data.</p>}
        </div>
        <div className="mt-3 hidden overflow-x-auto lg:block">
          <table className="w-full text-xs text-[#C3D0E2]">
            <thead className="text-left text-[#7E91AC]"><tr><th className="p-2">No</th><th>Waktu</th><th>Tipe</th><th>Nopol</th><th>Kendaraan</th><th>Pihak</th><th>WO</th><th>Pengemudi</th><th>Petugas</th><th>Status</th><th>Foto</th></tr></thead>
            <tbody>
              {rows.map((m) => (
                <tr key={m.id} className="border-t border-white/5">
                  <td className="p-2 font-mono">{m.number}</td><td>{m.date} {m.time}</td><td className={m.type === "IN" ? "text-emerald-300" : "text-blue-300"}>{m.type}</td>
                  <td className="font-bold text-white">{m.license_plate}</td><td>{m.vehicle || "-"}</td><td>{m.party}</td><td>{m.wo_number || "-"}</td>
                  <td>{m.driver}</td><td>{m.officer_name}</td><td className={SB[m.recon_status] || ""}>{m.recon_status}</td>
                  <td><div className="flex gap-1">{m.photo_ids.map((pid) => <PhotoThumb key={pid} pid={pid} />)}</div></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

function PhotoThumb({ pid }) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let u; api.get(`/security/photos/${pid}/file`, { params: { variant: "watermark" }, responseType: "blob" }).then((r) => { u = URL.createObjectURL(r.data); setUrl(u); }).catch(() => {});
    return () => { if (u) URL.revokeObjectURL(u); };
  }, [pid]);
  return url ? <a href={url} target="_blank" rel="noreferrer"><img src={url} alt="" className="h-9 w-9 rounded object-cover" data-testid="log-photo" /></a> : <div className="h-9 w-9 rounded bg-white/5" />;
}
